module.exports = __webpack_public_path__ + "img/dangga heights.e84f1992.jpg";